import React, { useMemo, useState } from 'react';
import { useRecoilState } from 'recoil';
import { replyModalState } from '@atom/modal/replyModal';
import ModalWrapper from '@components/wrapper/Modal/ModalWrapper';
import { ModalHeader, ModalInner } from '@components/wrapper/Modal/ModalStyle';
import CloseBtn from '@components/dataEntry/button/CloseBtn/CloseBtn';
import Button from '@components/dataEntry/button/Button';
import CommentQuill from '@components/library/Quill/CommentQuillLazy';

function ReplyModal() {
  const [modal, setModal] = useRecoilState(replyModalState);
  const [contents, setContents] = useState('');

  if (!modal.open) return null;

  return (
    <ModalWrapper outsideClick={() => setModal((p) => ({ ...p, open: false }))} contentStyle={{ maxWidth: 560 }}>
      <ModalHeader>
        <CloseBtn onClick={() => setModal((p) => ({ ...p, open: false }))} />
        <div style={{ textAlign: 'left' }}>
          <h6>답글 작성</h6>
        </div>
        <Button onClick={() => setModal((p) => ({ ...p, open: false }))}>올리기</Button>
      </ModalHeader>
      <ModalInner style={{ overflow: 'hidden' }}>
        <CommentQuill
          value={contents}
          onChange={setContents}
          placeholder="답글을 입력해 주세요. @멤버호출 /이모티콘 [[봇 코멘트]]"
          minHeight={120}
          maxHeight={220}
          noControls
          id={`${modal.collectionPath}-${modal.threadId}-reply`}
          type="editor"
          setToolbar={{ emoji: true, video: true, link: true }}
          collectionPath={modal.collectionPath}
        />
      </ModalInner>
    </ModalWrapper>
  );
}

export default React.memo(ReplyModal);


